import { Box, CircularProgress, Paper } from "@mui/material";

export const LoadingPaper = () => {
  return (
    <Paper sx={{p: 3}}>
      <Box sx={{display: "flex", justifyContent: "center"}}>
        <CircularProgress size={30} sx={{my: 3}}/>
      </Box>
    </Paper>
  );
}
